import { Checkbox } from '@components/checkbox';
import { formatCurrency } from '@utils/number';
import { Typography } from '@mui/material';
import { TableGridBaseColDef, TableGridRenderCellParams } from '@components/table/types/TableColumnDef.type';

export const getExcessPremiumColumns = ({
  excessCoverage,
  updateExcessCoverage,
  updatePrintLimit,
  isInternalUser,
}: {
  excessCoverage: number;
  updateExcessCoverage: (excessCoverage: number, printLimitAttributeKey: string) => void;
  updatePrintLimit: (printLimitCoverage: string, checked: boolean) => void;
  isInternalUser: boolean;
}): TableGridBaseColDef<any>[] => {
  const excessPremiumColumns: TableGridBaseColDef[] = [
    {
      renderHeader: () => '',
      headerName: undefined,
      field: 'updateExcessCoverage',
      flex: 0.5,
      sortable: false,
      renderCell: (params: TableGridRenderCellParams) => (
        <Checkbox
          checked={params.row.eachEvent === excessCoverage}
          onClick={() => updateExcessCoverage(params.row.eachEvent, params.row.printLimitKey)}
        />
      ),
    },
    {
      field: 'eachEvent',
      headerName: 'Each Event Limit',
      flex: 1,
      sortable: false,
      renderCell: (params: TableGridRenderCellParams) => (
        <Typography variant='bodySmall'>{formatCurrency(params.row.eachEvent, { minimumPrecision: 0 })}</Typography>
      ),
    },
    {
      field: 'estimatedPremiumWTerrorism',
      headerName: 'Estimated Premium with Terrorism',
      flex: 2,
      sortable: false,
      renderCell: (params: TableGridRenderCellParams) => (
        <Typography variant='bodySmall'>
          {formatCurrency(params.row.estimatedPremiumWTerrorism, { minimumPrecision: 0 })}
        </Typography>
      ),
    },
    {
      field: 'esimatedPremiumWOTerrorism',
      headerName: 'Estimated Premium without Terrorism',
      flex: 2,
      sortable: false,
      renderCell: (params: TableGridRenderCellParams) => (
        <Typography variant='bodySmall'>
          {formatCurrency(params.row.estimatedPremiumWOTerrorism, { minimumPrecision: 0 })}
        </Typography>
      ),
    },
  ];

  if (isInternalUser) {
    excessPremiumColumns.push({
      field: 'limitPrint',
      headerName: 'Include Limit',
      sortable: false,
      renderCell: (params: TableGridRenderCellParams) => {
        const forceSelected = params.row.eachEvent === excessCoverage;
        return (
          <Checkbox
            checked={params.row.limitPrint === true}
            disabled={forceSelected ? true : false}
            onClick={(e: any) => {
              const checked = (e.target as HTMLInputElement).checked;
              updatePrintLimit(params.row.printLimitKey, checked);
            }}
          />
        );
      },
    });
  }

  return excessPremiumColumns;
};
